module.exports = __webpack_public_path__ + "img/product11.6d6748f3.png";